<template>
  <!-- 环境检测 -->
  <div>
    <div>
      <img class="top_img1" src="../../assets/img/huanjingjiance.jpg" />
    </div>
    <div style="background: #FFF">
        <div class="body">
      <div class="title">业务范围</div>
      <div class="list">
        <div
          :class="[item.flag ? 'list_item active' : 'list_item']"
          @click="changeItem(item)"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="list_name">{{title}}</div>
      <div class="content">
        <div class="content_list">
          <div class="content_list_item" v-for="(item,index) in contentList" :key="index">
            {{item}}
          </div>
        </div>
        <div class="text">
          {{contet_text}}
        </div>
      </div>
    </div>
    </div>
    <div class="post">
      <contentIndex :initInfo="info"></contentIndex>
    </div>
  </div>
</template>
<script>
import contentIndex from "./index.vue"

export default {
  components: { contentIndex },
  data() {
    return {
      info: {
        type: 6,
        testTypeList: [],
      },
      list: [
        {
          id: 1,
          name: "水",
          flag: true,
        },
        {
          id: 2,
          name: "土壤",
          flag: false,
        },
        {
          id: 3,
          name: "气",
          flag: false,
        },
        {
          id: 4,
          name: "固废",
          flag: false,
        },
        {
          id: 5,
          name: "噪音",
          flag: false,
        },
      ],
      title: '水',
      contentList: ['国标','行标','CMA/CNAS资质'],
      contet_text: '银、锌、锡、硒、铜、铁、锑、钛、锶、砷、铅、铍、硼、镍、钠、钼、锰、镁、铝、硫、磷、锂、钾、硅、钴、铬、镉、锆、钙、钒、铋、钡、锌、砷、硼、硅、汞、阴离子表面活性剂、悬浮物、细菌总数、五日生化需氧量、石油类、氰化物、耐热大肠菌群、氯化物、硫酸盐、硫化物、挥发酚、化学需氧量、类类大肠菌、植物物油、大肠菌群、氨氮、pH值、六价铬'
    };
  },
  methods: {
    changeItem(e) {
      this.list.forEach(item => item.flag = (item.id === e.id));
      if(e.id === 1){
        this.title = '水'
        this.contentList = ['国标','行标','CMA/CNAS资质']
        this.contet_text = '银、锌、锡、硒、铜、铁、锑、钛、锶、砷、铅、铍、硼、镍、钠、钼、锰、镁、铝、硫、磷、锂、钾、硅、钴、铬、镉、锆、钙、钒、铋、钡、锌、砷、硼、硅、汞、阴离子表面活性剂、悬浮物、细菌总数、五日生化需氧量、石油类、氰化物、耐热大肠菌群、氯化物、硫酸盐、硫化物、挥发酚、化学需氧量、类类大肠菌、植物物油、大肠菌群、氨氮、pH值、六价铬'
      }
      if(e.id === 2){
        this.title = '土壤'
        this.contentList = ['国标','行标','CMA/CNAS资质']
        this.contet_text = '锌、钒、砷、钼、锑、铜、锌、铅、镉、铬、汞、砷、锰、钡、钒、锶、钛、钙、镁、铁、铝、钾、硅'
      }
      if(e.id === 3){
        this.title = '气'
        this.contentList = ['国标','行标','CMA/CNAS资质']
        this.contet_text = '甲烷、臭气浓度、氨、氣、硫化氢、非甲烷总烃、总烃'
      }
      if(e.id === 4){
        this.title = '固废'
        this.contentList = ['国标','行标','CMA/CNAS资质']
        this.contet_text = '银、锌、铜、铁、锑、钛、铊、锶、铅、铍、总镍、钠、锰、镁、铝、钾、钴、铬、镉、钙、钒、钡'
      }
      if(e.id === 5){
        this.title = '噪音'
        this.contentList = ['国标','行标','CMA/CNAS资质']
        this.contet_text = '工业企业厂界噪声（昼间、夜间）、社会生活环境噪声（昼间、夜间）、建筑施工厂界噪声（昼间、夜间）'
      }
    },
  },
};
</script>
<style scoped lang="scss">
.body {
  width: 80%;
  max-width: 1920px;
  /* min-width: 1440px; */
  margin: 0 auto;
  .title {
    font-size: 22px;
    color: #333;
    position: relative;
    text-align: center;
    padding-bottom: 10px;
    margin-top: 30px;
  }
  .title::after {
    display: block;
    content: "";
    position: absolute;
    bottom: 0;
    left: calc(50% - 3em);
    width: 6em;
    height: 2px;
    background: #6681f0;
  }
  .list {
    // width: 70%;
    width: 800px;
    display: flex;
    margin: 60px auto;
    justify-content: space-around;
    .list_item {
      width: 80px;
      height: 30px;
      font-size: 16px;
      text-align: center;
      line-height: 30px;
      color: #333333;
      border-radius: 3px;
      cursor: pointer;
      border: 1px solid #666666;
    }
    .active {
      background: #546ef5;
      color: #ffffff;
    }
  }
  .list_name {
    width: 85%;
    min-width: 800px;
    margin: 0 auto;
    font-size: 22px;
    color: #333;
    border-bottom: 1px solid #333333;
    padding-bottom: 5px;
  }
  .content {
    width: 85%;
    min-width: 800px;
    margin: 0 auto;
    margin-top: 20px;
    .content_list {
      display: flex;
      .content_list_item {
        padding: 2px 8px;
        font-size: 12px;
        color: #ffffff;
        background: #2039bc;
        border-radius: 2px;
        margin-right: 20px;
      }
    }
    .text {
      margin-top: 15px;
      padding-bottom: 40px;
    }
  }
}
.post {
  width: 100%;
  background: #ffffff;
  padding-top: 140px;
  margin-top: 20px;
}
</style>
